// Shift & Spark — showcase cards
// Generated 19 August 2026 from the current deck (v4).
// Te reo terms match the completed te reo review; meanings are the reviewer's.
// 'nzc' and 'ukd' are gone. Cards print a command word instead.
// Supersedes the earlier data.NEW.js: K-17, K-24 and S-22 carried longer step and
// example text that overflowed the card. This file has the shortened, verified text.

window.SS_CARDS = {
  "spark": [
    {
      "id": "K-01",
      "title": "THE IMPOSTER",
      "tereo": "Te Tāware",
      "meaning": "To deceive/trick",
      "activity_type": "Retrieval Practice",
      "steps": [
        {
          "label": "Assign",
          "text": "Five groups each prepare a 30-second concept summary. Teacher hands each a folded slip face-down: four say 'Accurate', one 'Imposter'. The Imposter group hides one plausible factual error."
        },
        {
          "label": "Present",
          "text": "Each group presents in turn. Class listens to all five, no interrupting. Discussion begins only after all groups have presented."
        },
        {
          "label": "Eject",
          "text": "Class votes on the Imposter group, but must name the exact error, not just the group. No vote counts without a named error."
        }
      ],
      "subjects": "All subjects",
      "time": "10 min",
      "materials": "Prep: 5 folded slips",
      "energy": "high",
      "energy_n": 3,
      "lookfors": "You want the room split over which error was planted. If half the class accuses a group that was accurate, that topic needs reteaching. A group that votes without naming a specific error was guessing, not listening.",
      "why": "Naming the exact error, not just the group, is what forces close listening. Handing students the power to plant and catch errors is whakamana: their judgement, not the teacher's, decides the round.",
      "subject_example": "In Practice: five groups summarise one body system each. One claims the heart oxygenates the blood, with total confidence. A student: 'the lungs do that, the heart only moves it.'",
      "lit_num": "literacy",
      "command": "Justify",
      "researcher": "Retrieval Practice, Roediger & Karpicke, 2006",
      "research_ref": "Retrieval Practice, Roediger & Karpicke, 2006"
    },
    {
      "id": "K-17",
      "title": "THE ROLE REVERSAL",
      "tereo": "Te Huri Tūnga",
      "meaning": "Role swap",
      "activity_type": "Retrieval & Competition",
      "steps": [
        {
          "label": "Arm",
          "text": "Teams write three questions on today's topic and an accurate answer on the back of each."
        },
        {
          "label": "Fire",
          "text": "Teams take turns questioning the teacher. A question that stumps you scores 3 points. One you answer correctly costs them a point."
        },
        {
          "label": "Judge",
          "text": "The class decides whether your answer was good enough. Three stumps and you are out. Highest score takes the round."
        }
      ],
      "subjects": "All subjects",
      "time": "12 min",
      "materials": "Pen + paper",
      "energy": "high",
      "energy_n": 3,
      "lookfors": "The questions a team writes show you more than their answers usually do. Depth stumps you, trivia does not, and teams learn that fast once an obscure date has cost them a point. When they get you, say so and write their answer down.",
      "why": "Writing a question you can answer yourself is harder than answering one, and aiming it at you makes a team check twice. Te Huri Tūnga only means anything if you can lose. A teacher who is never stumped has handed the class a quiz. Ako runs both ways, and being stumped in front of them is what that looks like.",
      "subject_example": "In Practice: 'why is a rāhui put on after a drowning?' The teacher: 'to let the area recover.' The team: 'that's the fishing one. This one is tapu. Nobody takes food from water that has taken someone.' Ruled a stump.",
      "lit_num": "literacy",
      "command": "Create",
      "researcher": "Elaborative Interrogation, Pressley et al., 1992",
      "research_ref": "Elaborative Interrogation, Pressley et al., 1992"
    },
    {
      "id": "K-02",
      "title": "FASTEST FINGER",
      "tereo": "Matimati Tere",
      "meaning": "Fast finger",
      "activity_type": "Retrieval Practice",
      "steps": [
        {
          "label": "Pose",
          "text": "Teacher poses a question. Teams confer quietly and one rep writes the answer on a mini whiteboard. New rep each round, so everyone writes."
        },
        {
          "label": "Race",
          "text": "Boards up when the team is ready, no signal. Verbal answers do not count. First correct board takes the point, and a wrong board up first passes it on."
        },
        {
          "label": "Keep it",
          "text": "To keep the point, the winning team adds one detail beyond the answer. If boards go up together, the most precise takes it. Run as many rounds as the time allows."
        }
      ],
      "subjects": "All subjects",
      "time": "8 min",
      "materials": "Mini whiteboards + markers",
      "energy": "high",
      "energy_n": 3,
      "lookfors": "Watch for the huddle before the board goes up. Even a two-second confer means the whole team had to think. Teams that confer every round and still lose need more time with the content, not more rounds.",
      "why": "Roediger and Karpicke found that producing an answer beats being shown it again, and the race is what makes every team produce one. Teams must agree fast, so everyone thinks rather than deferring to the loudest voice, and they self-regulate: checking before raising rather than guessing and losing ground.",
      "subject_example": "In Practice: 'the landform where a river bends.' 'Meander!' Then, to keep the point: 'it forms where the current runs fastest on the outside bend.'",
      "lit_num": "literacy",
      "command": "Identify",
      "researcher": "Retrieval Practice, Roediger & Karpicke, 2006",
      "research_ref": "Retrieval Practice, Roediger & Karpicke, 2006"
    },
    {
      "id": "K-24",
      "title": "THE LIVE SCOREBOARD",
      "tereo": "Te Papa Tapeke Mataora",
      "meaning": "Live scoreboard",
      "activity_type": "Formative Assessment",
      "steps": [
        {
          "label": "Draw the grid",
          "text": "Four columns on the board, labelled Fact, Cause, Counter-example, Question. Every team gets a row."
        },
        {
          "label": "Tick a box",
          "text": "When a student speaks, their team names the column it belongs in. If you agree, tick that box in their row. One tick per student."
        },
        {
          "label": "Finish",
          "text": "After twelve minutes the most ticks wins. A team that ticks all four wins outright."
        }
      ],
      "subjects": "All subjects",
      "time": "12 min",
      "materials": "Whiteboard",
      "energy": "medium",
      "energy_n": 2,
      "lookfors": "Watch which column stays empty longest. A class that fills Fact in a minute and cannot find a Counter-example has told you what to teach next. Making them name the column is half the thinking.",
      "why": "Black and Wiliam found that assessment only helps when it changes what happens next. A grid rewards the range of a team's thinking rather than the volume of its talking, so no team wins by repeating the one move it is good at.",
      "subject_example": "In Practice, on wartime rationing. Fact: 'sugar was rationed from 1940.' Cause: 'the convoys were being sunk.' Counter-example: 'Bengal starved in 1943, in the same empire.' Question: 'who decided what counted as essential?'",
      "lit_num": "literacy",
      "command": "Compare",
      "researcher": "Formative Assessment, Black & Wiliam, 1998",
      "research_ref": "Formative Assessment, Black & Wiliam, 1998"
    },
    {
      "id": "K-03",
      "title": "THE HUMAN TIMELINE",
      "tereo": "Te Rārangi Wā",
      "meaning": "Human sequence",
      "activity_type": "Kinesthetic Retrieval",
      "steps": [
        {
          "label": "Distribute",
          "text": "Write 8-12 events or steps on cards, plus one that does not belong. Hand them out as students arrive; everyone else checks and may challenge one placement."
        },
        {
          "label": "Arrange",
          "text": "No talking, gestures only. Card-holders put themselves in order and push the imposter out."
        },
        {
          "label": "Justify",
          "text": "Each student reads their card and says why they stand there. The ejected student goes last: why did it not belong?"
        }
      ],
      "subjects": "All subjects",
      "time": "8 min",
      "materials": "Prep: 8-12 event cards + 1 imposter",
      "energy": "high",
      "energy_n": 3,
      "lookfors": "A wrong ejection is the most useful thing that can happen: that card is the one they do not understand the place of. A student in the right spot who cannot say why is worth a quiet follow-up.",
      "why": "Removing talk forces a different kind of thinking: students who normally follow the loudest voice have to work out the logic themselves. Novak and Gowin argued that understanding sits in the link rather than the node, which is why the justification step matters as much as the position in the line.",
      "subject_example": "In Practice: nine students hold 1914 event cards and line up, then push one out: 'Versailles is five years too late.' The rest argue over whether mobilisation comes before Russia's response.",
      "lit_num": "literacy",
      "command": "Justify",
      "researcher": "Concept Mapping, Novak & Gowin, 1984",
      "research_ref": "Concept Mapping, Novak & Gowin, 1984"
    }
  ],
  "shift": [
    {
      "id": "S-05",
      "title": "THE WORD BUDGET",
      "tereo": "Te Tahua Kupu",
      "meaning": "Word budget",
      "activity_type": "Vocabulary & Language",
      "steps": [
        {
          "label": "Compress",
          "text": "Summarise the whole lesson in exactly fifteen words. Not fourteen, not sixteen. Fifteen."
        },
        {
          "label": "Check",
          "text": "Swap with a partner. The partner counts the words and challenges anything that is not accurate. One revision allowed."
        },
        {
          "label": "Post",
          "text": "Final versions go on the wall. Read them, then find two that disagree about what mattered most and settle it as a class."
        }
      ],
      "subjects": "All subjects",
      "time": "5 min",
      "materials": "Sticky note + pen",
      "energy": "low",
      "energy_n": 1,
      "lookfors": "Look for two summaries that kept different things and ask both students why theirs had to be in. That argument is the content discussion, and it will not happen if you only check the word count.",
      "why": "Fifteen words forces a decision about what the lesson was for. Students who find it easy have usually not seen the complexity yet. The ones who understand most find it hardest, because they have more to leave out.",
      "subject_example": "In Practice: osmosis in exactly fifteen words. 'Water crosses a membrane from high water concentration to low, no energy required, until balanced.' The sixteenth word was 'gradually', and a partner made her prove it was worth the space.",
      "lit_num": "literacy",
      "command": "Explain",
      "researcher": "SOLO Taxonomy, Biggs & Collis, 1982",
      "research_ref": "SOLO Taxonomy, Biggs & Collis, 1982"
    },
    {
      "id": "S-11",
      "title": "QUESTION ONLY",
      "tereo": "Pātai Anake",
      "meaning": "Questions only",
      "activity_type": "Formative Reflection",
      "steps": [
        {
          "label": "Rule",
          "text": "Three minutes. The teacher opens with a question about today's topic, and teams answer in turn, only ever with another question."
        },
        {
          "label": "Out",
          "text": "A team is out if it makes a statement, stalls for more than ten seconds, or asks something that opens no new ground. The teams already out are the ones who rule on that."
        },
        {
          "label": "Last in",
          "text": "The last team still asking takes the round. Run it again with a new question if the clock allows."
        }
      ],
      "subjects": "All subjects",
      "time": "4 min",
      "materials": "None needed",
      "energy": "medium",
      "energy_n": 2,
      "lookfors": "Listen for a question that names something specific in the text. When a team is ruled out, ask the team that called it what the question failed to open.",
      "why": "Students can only ask about things they know enough to be unsure of, so how long a team survives shows what they are holding. Answering in turn means nobody waits for someone else to speak, and the teams already out stay in the work by ruling on the ones still going.",
      "subject_example": "In Practice: 'why does he lie in chapter one?' 'Is it a lie if he believes it?' 'Does the book ever say he is wrong?' The fourth team is ruled out for going back over ground.",
      "lit_num": "literacy",
      "command": "Create",
      "researcher": "Metacognitive Monitoring, Flavell, 1979",
      "research_ref": "Metacognitive Monitoring, Flavell, 1979"
    },
    {
      "id": "S-22",
      "title": "STAKE YOUR CLAIM",
      "tereo": "Te Whakaū Whakapae",
      "meaning": "Stake a claim",
      "activity_type": "Metacognition",
      "steps": [
        {
          "label": "Answer",
          "text": "Five questions on the board. Students answer each one, then tag it certain, fairly sure, or guessing."
        },
        {
          "label": "Reveal",
          "text": "Give the answers. Students circle anything they tagged certain and got wrong, and underline anything they guessed and got right."
        },
        {
          "label": "Sort",
          "text": "Next to each circle, one line: what made that answer feel certain? Those are the ones to bring back next lesson."
        }
      ],
      "subjects": "All subjects",
      "time": "6 min",
      "materials": "Prep: 5 questions",
      "energy": "low",
      "energy_n": 1,
      "lookfors": "Start with the circles. A student will not revise something they think they already know, so those errors survive a whole term. Underlines need a different conversation, because that student knows more than they will admit to.",
      "why": "Dunlosky and Metcalfe found students are overconfident about what they know. A wrong answer you were sure of is more dangerous than one you guessed, and tagging in words rather than a number makes students commit to a real claim about their own certainty.",
      "subject_example": "In Practice: 'multiplying always makes a number bigger', tagged certain, circled. The teacher: 'only when you multiply by more than 1. Multiply by a half and 8 becomes 4. Multiply by 0 and you get 0.'",
      "lit_num": "literacy",
      "command": "Evaluate",
      "researcher": "Metacognitive Calibration, Dunlosky & Metcalfe, 2009",
      "research_ref": "Metacognitive Calibration, Dunlosky & Metcalfe, 2009"
    },
    {
      "id": "S-24",
      "title": "SILENT DEBATE",
      "tereo": "Taupatupatu Wahangū",
      "meaning": "Silent debate",
      "activity_type": "Formative Reflection",
      "steps": [
        {
          "label": "Write the question",
          "text": "Put a question on the board that can honestly go either way, with FOR and AGAINST columns under it."
        },
        {
          "label": "Post",
          "text": "Six minutes, no talking. One idea per sticky note, in either column, and you can use both. To rebut a note, post yours opposite and draw an arrow to it."
        },
        {
          "label": "Read",
          "text": "Read the wall in silence, then have a class discussion: which column is stronger, and which note did the most work?"
        }
      ],
      "subjects": "Humanities, Social Sciences",
      "time": "10 min",
      "materials": "Sticky notes",
      "energy": "medium",
      "energy_n": 2,
      "lookfors": "Count the arrows. A note nobody answered may still be right, but a note with three arrows on it changed the argument. A student who posted three times and drew none has not read the wall.",
      "why": "Silent debate takes the floor away from whoever is quickest to speak, so the argument is judged on the page rather than on delivery. Students who never win a spoken discussion often write the note everything else attaches to.",
      "subject_example": "In Practice: a silent debate on a formal apology for the Dawn Raids. Someone posts 'governments apologise for what governments did, that's the whole point of them' and three arrows land on it within a minute.",
      "lit_num": "literacy",
      "command": "Justify",
      "researcher": "ICAP Framework, Chi & Wylie, 2014",
      "research_ref": "ICAP Framework, Chi & Wylie, 2014"
    },
    {
      "id": "S-40",
      "title": "THE ANALOGY FORGE",
      "tereo": "Te Tārai Tairitenga",
      "meaning": "Build a comparison",
      "activity_type": "Analytical Thinking",
      "steps": [
        {
          "label": "Forge",
          "text": "Teacher names the concept. Each student writes one analogy for it: ___ is like ___ because ___."
        },
        {
          "label": "Break it",
          "text": "Two minutes to write down where the analogy stops working. Every analogy breaks somewhere."
        },
        {
          "label": "Rate",
          "text": "Swap with a partner, who rates it 1 shallow, 2 useful, 3 genuinely illuminating and justifies the number. Anything rated 3 gets read to the class."
        }
      ],
      "subjects": "All subjects",
      "time": "6 min",
      "materials": "Pen + paper",
      "energy": "low",
      "energy_n": 1,
      "lookfors": "Read the breaks first. Anyone can find a resemblance. What you want is a student who can say exactly where theirs stops working.",
      "why": "Where an analogy stops working shows the limits of a concept more clearly than where it holds. Finding the failure point and explaining it takes more than spotting the similarity.",
      "subject_example": "In Practice: 'a circuit is like water in pipes because the pump pushes it round.' The break: 'water spills if you cut the pipe, but cut a wire and nothing pours out.'",
      "lit_num": "literacy",
      "command": "Create",
      "researcher": "Elaborative Interrogation, Pressley et al., 1992",
      "research_ref": "Elaborative Interrogation, Pressley et al., 1992"
    }
  ]
};
